import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type ThemeVariant = 'light' | 'dark';

interface ThemeState {
  variant: ThemeVariant;
}

const themeSlice = createSlice({
  name: 'theme',
  initialState: { variant: 'dark' } as ThemeState,
  reducers: {
    setTheme(state, action: PayloadAction<ThemeVariant>) {
      state.variant = action.payload;
    },
    toggleTheme(state) {
      state.variant = state.variant === 'dark' ? 'light' : 'dark';
    },
  },
});

export const { setTheme, toggleTheme } = themeSlice.actions;
export default themeSlice.reducer;
